import Cities from './city-list.json';

export function getCities(): string[] {
    return Cities;
}
